export const isRequired = value => (value ? undefined : 'This is a required field')
export const isNumber = value => isNaN(value) ?  'Not a number' : undefined
export const isEmail= value => (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(value)) ?  'Not a valid email address'  : undefined
export const isText= value => (!/^(?![\s.]+$)[a-zA-Z\s.]*$/.test(value)) ? 'Invalid characters' : undefined 
export const isPhone = value => (!/^.{7,}$/.test(value)) ? 'Invalid Phone Number' : undefined 
